<template>
    <div id="app">
        <Navbar v-show="$route.meta && $route.meta.hasNav"/>
        <transition :name="transitionName">
            <router-view/>
        </transition>
        <Tabbar v-show="$route.meta && $route.meta.hasTab"/>
    </div>
</template>

<script>
    import Navbar from './components/Navbar'
    import Tabbar from './components/Tabbar'

    export default {
        data() {
            return {
                transitionName: ''
            }
        },
        components: {
            Navbar,
            Tabbar
        },
        watch: {
            /*
             * 使用watch 监听$router的变化
             * 如果to索引大于from索引,判断为前进状态,反之则为后退状态
             * 设置动画名称
             */
            $route(to, from) {
                if (to.meta && to.meta.activeTab) {
                    this.$store.dispatch('app/setActiveTab', to.meta.activeTab)
                }
                if (to.meta.index === from.meta.index) {
                    this.transitionName = ''
                } else if (to.meta.index > from.meta.index) {
                    this.transitionName = 'slide-left'
                } else {
                    this.transitionName = 'slide-right'
                }
            }
        }
    }
</script>


<style lang="scss">

</style>
